export class TokenInfo {
	public Token: string;
	public RefreshToken: string;
	public ExpiresIn: number;
}
